import React, { forwardRef } from 'react';

import { Stack, Typography } from '@lyearn/ui';
import { formatSecondsToTime } from '@/modules/session/utils/formatSecondsToTime';

import { CountdownTimerProps } from './types';

const TIME_WARNING_VALUE = 5;

const CountdownTimer = forwardRef<HTMLDivElement, CountdownTimerProps>((props, forwardedRef) => {
  const { timeLeft, ...rest } = props;
  const { timeArray } = formatSecondsToTime((timeLeft || 0) * 1000, true);

  const formattedTimeArray = timeArray.map((num) => num.toString().padStart(2, '0'));

  const getTextColor = (timeUnitValue: string, index: number) => {
    if (Number(timeUnitValue) === 0) {
      return 'text-text-placeholder';
    }
    if (index === formattedTimeArray.length - 1 && timeLeft! <= TIME_WARNING_VALUE) {
      return 'text-text-error';
    }
  };

  if (!timeLeft) {
    return null;
  }

  return (
    <Stack
      ref={forwardedRef}
      alignItems="center"
      divider={<Typography variant="heading-xxs">:</Typography>}
      gapX={2}
      {...rest}>
      {formattedTimeArray.map((timeUnitValue, index) => (
        <Typography key={index} color={getTextColor(timeUnitValue, index)} variant="heading-xxs">
          {timeUnitValue}
        </Typography>
      ))}
    </Stack>
  );
});

export default CountdownTimer;
